import { DashBoardData } from '../../interface/response/DashBoardResponse'
import { apiService } from '../apiService'

export const dashBoardApiService = apiService.injectEndpoints({
  endpoints: (builder) => ({
    getDashBoardDetails: builder.query({
      query: () => {
        return {
          url: `/Dashboard/ViewDashboardDetails`,
        }
      },
      transformResponse: (response: { data: DashBoardData[] }) => {
        return response?.data
      },
      providesTags: ['DashboardList'],
    }),
    getApplicationTenantConfigurationDetails: builder.query({
      query: () => ({
        url: '/ApplicationConfiguration/GetApplicationTenantConfigurationDetails',
        method: 'GET',
      }),
      transformResponse: (response) => {
        return response.data
      },
    }),
  }),
})

export const {
  useLazyGetDashBoardDetailsQuery,
  useLazyGetApplicationTenantConfigurationDetailsQuery,
} = dashBoardApiService
